import { render, staticRenderFns } from "./choose-shop.vue?vue&type=template&id=260d49d7"
import script from "./choose-shop.vue?vue&type=script&lang=js"
export * from "./choose-shop.vue?vue&type=script&lang=js"
import style0 from "./choose-shop.vue?vue&type=style&index=0&id=260d49d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports